import React from 'react';
import ButtonRedirect from '../../../components/Login/ButtonRedirect';
import ContainerLogin from '../../../components/Login/ContainerLogin';
import FooterLogin from '../../../components/Login/FooterLogin';
import LogoLogin from '../../../components/Login/LogoLogin';
import MainLogin from '../../../components/Login/MainLogin';
import { MessageConfirmedEmail } from '../../../components/Login/MessagesLogin';

export default function TemplateConfirmedEmail() {
  return (
    <ContainerLogin>
      <MainLogin>
        <LogoLogin />
        <MessageConfirmedEmail>
          <h2>Parabéns e Seja bem-vindo(a)!</h2>
          <p>Agora que você já confirmou seu email, poderá ter acesso ao nosso sistema.</p>
          <p>Basta clicar no botão abaixo e efetuar seu primeiro login.</p>
        </MessageConfirmedEmail>
        <ButtonRedirect href="/login">Entrar no sistema</ButtonRedirect>
      </MainLogin>
      <FooterLogin />
    </ContainerLogin>
  );
}
